import React from 'react';
import PropTypes from 'prop-types';
import styles from './Articles.module.sass';
import Article from './article/Article';
import HighlightedArticle from './highlighted_article/HighlightedArticle';

function Articles(props) {
  const { articles: articlesFromProps } = props;
  const articles = articlesFromProps.filter((article) => !article.highlighted);
  const highlightedArticle = articlesFromProps.find((article) => article.highlighted);
  const firstArticlesBlock = articles.splice(0, 3);
  const secondArticlesBlock = articles.splice(0, 6);
  const restArticles = articles;

  return (
    <div className={styles.articles}>
      <div className={styles['articles-block']}>
        { firstArticlesBlock.map(((article) => (
          <div className={styles['article-wrapper']} key={article.id}>
            <Article
              article={article}
              className={styles.article}
              lazyLoad={false}
            />
          </div>
        )))}
      </div>

      <div className={styles['recent-press-wrapper']}>
        <div className={styles['recent-press']}>
          RECENT PRESS
        </div>
      </div>

      <div className={styles['articles-block']}>
        { secondArticlesBlock.map(((article) => (
          <Article
            key={article.id}
            article={article}
            className={styles.article}
          />
        )))}
      </div>

      { highlightedArticle && <HighlightedArticle article={highlightedArticle} /> }

      <div className={styles['articles-block']}>
        { restArticles.map(((article) => (
          <Article
            key={article.id}
            article={article}
            className={styles.article}
          />
        )))}
      </div>
    </div>
  );
}

Articles.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
};

export default Articles;
